// @theme component
export const NEVIS_ERRORS = {
    AUTHENTIFICATOR_NOT_FOUND: 105
};
